

import Vue from 'vue'
import App from './App'
import router from './router'
import $ from 'jquery'
import api from './api/api_php'

Vue.config.productionTip = false
import cookie from 'js-cookie'

import './assets/js/rem.js'


import VueScroller from 'vue-scroller'
Vue.use(VueScroller)

import VueAwesomeSwiper from 'vue-awesome-swiper'


import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper)


import VueTouch from 'vue-touch'

Vue.use(VueTouch, {name: 'v-touch'})


import VueResource from 'vue-resource'
Vue.use(VueResource)


import iView from 'iview';
Vue.use(iView);

import 'iview/dist/styles/iview.css';


import AlertPlugin from 'vux/src/plugins/alert/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'

Vue.use(AlertPlugin)
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin, {
position: 'middle',
type: 'text'
})
Vue.use(DatetimePlugin)



import talkUrl from './url_config'

var urlObj = talkUrl(process.env);


cookie.set('wx_token', '317CD0382B2AE8318AB08DB5A47433E9');
Vue.prototype.stockServer = urlObj.java_axiosUrl + '/stock/stockMarket';
Vue.prototype.Domain = urlObj.Domain;



Date.prototype.Format = function (fmt) { //author: meizz
var o = {
"M+": this.getMonth() + 1, //月份
"d+": this.getDate(), //日
"h+": this.getHours(), //小时
"m+": this.getMinutes(), //分
"s+": this.getSeconds(), //秒
"q+": Math.floor((this.getMonth() + 3) / 3), //季度
"S": this.getMilliseconds() //毫秒
};
if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
for (var k in o)
if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
return fmt;
}

router.beforeEach((to, from, next) => {
clearInterval(window.timr);
if (from.path == '/fr/app/investment/index' || from.path == '/fr/app/inner/index') {
var top = document.querySelector('body').scrollTop;
localStorage.setItem('top', top)
};
Vue.$vux.loading.hide();

if (to.path) {
window._hmt.push(['_trackPageview', '/#' + to.fullPath]);
};
var a = $('head');
if(to.path.indexOf('/stock/') != -1){
var style = $('<style type="text/css" name="asd"></style>');
style.html('*,*:before, *:after{box-sizing:inherit !important;}');
a.append(style);
}else{

}
next();
})

var u = navigator.userAgent;
var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; 
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 


import share from '@/assets/js/share'

const shareArr = ['/fr/app/jftc', '/fr/app/investment/index','/fr/app/investment/tzywDetails'];

const intervalFun = function(val){
window.timr_num = 0;
window.timr = setInterval(()=>{
window.timr_num += 200;
if(document.querySelector('.operation')){
if(val == 0){
document.querySelector('.operation').setAttribute('style','display:flex !important');
}else{
document.querySelector('.operation').setAttribute('style','display:none !important');
}
clearInterval(window.timr);
}
if(window.timr_num > 20000){
clearInterval(window.timr);
window.timr_num
}
},200)
}

router.afterEach((to, from) => {
if (to.path == '/fr/app/investment/index' || to.path == '/fr/app/inner/index') {} else {
document.documentElement.scrollTop = 0;
document.body.scrollTop = 0;
}
if(sessionStorage['module_id'] && sessionStorage['module_type']){
api.getProductExplain( res=> {
res = res.data;
if(sessionStorage.getItem('module_type1') == 1){
if(res.lmdescText){
console.log(1)
intervalFun(0);
}else{
intervalFun(1);
}
}else{
if(res.lmDescRecstock || res.opstyle || res.chsreason || res.riskalert || res.opskill || res.ajstperson || res.impnotice){
intervalFun(0);
}else{
intervalFun(1);
}
};
},{
type: Number(sessionStorage.getItem('module_type')),
moduleId: Number(sessionStorage.getItem('module_id'))
});
}

let path = to.path;
let path1 = to.fullPath;
if (shareArr.indexOf(path) != -1) {
if (isiOS) { // IOS
var url;
if (window.entryUrl == '' || window.entryUrl == undefined) {
url = `${urlObj.FRONT_BASE}${path1}`
window.entryUrl = url 
}
} else if (isAndroid) { // 安卓



}
}else{
if (isiOS) {
share({isShare:false});
}else{
setTimeout(function () {
share({isShare:false});
}, 0);
}
}
})


import store from './store'


/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: {
App
},
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js